import React from 'react';
import BriefHtml from '../brief/BriefHtml';
import styles from './GigApplicationPage.module.scss';

interface ProposalRowProps {
  title: string;
  titleHtml?: boolean;
  value: string;
  testID?: string;
}

function ProposalRow({title, titleHtml, value, testID}: ProposalRowProps) {
  return (
    <div className={styles.row} data-testid={testID}>
      <div className={styles.rowTitle}>
        {titleHtml ? <BriefHtml contentHtml={title} /> : title}
      </div>
      <div className={styles.rowValue}>{value}</div>
    </div>
  );
}

export default ProposalRow;
